import { Text } from '@mantine/core';

import { translate } from '@/shared/i18n/translate';

export const NotFoundResults = () => (
  <Text>{translate('commons.notFound.search')}</Text>
);
